import { useSessionConfiguration } from 'src/app/shared/hooks/sessionConfiguration';

import type { CountryBannerConfig, CountryBannerContext } from './types';

export function useCountryBannerBase(
	context: CountryBannerContext,
	petitionId?: string,
): CountryBannerConfig | undefined {
	const {
		featureConfigs: { countryBanner },
	} = useSessionConfiguration();

	if (!countryBanner) {
		return undefined;
	}

	if (!countryBanner.context.includes(context)) {
		return undefined;
	}

	// banner_petition_id means “this banner concerns this specific petition”,
	// therefore we don’t want to show that banner when already showing that petition
	if (petitionId && countryBanner.banner_petition_id && countryBanner.banner_petition_id === petitionId) {
		return undefined;
	}

	return countryBanner;
}
